import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  getRole,
  getRoleFailed,
  getRoleSuccess,
  getModule,
  getModuleFailed,
  getModuleSuccess,
  addRole,
  addRoleSuccess,
  addRoleFailed,
  updateRoleStatus,
  updateRoleStatusSuccess,
  updateRoleStatusFailed,
} from './slice';
import * as endpoints from './endpoints';
import { PERMISSION } from '@app/constants';

// ----------------------------------------

function* getRolesSaga(action: ReturnType<typeof getRole>): any {
  try {
    const result = yield call(request.get, endpoints.roles);

    yield put(getRoleSuccess(result.data));
  } catch (err) {
    yield put(getRoleFailed(err));
  }
}

function* getModuleSaga(action: ReturnType<typeof getModule>): any {
  try {
    const result = yield call(request.get, endpoints.module);

    yield put(getModuleSuccess(result.data));
  } catch (err) {
    yield put(getModuleFailed(err));
  }
}

function* addRoleSagas(action: ReturnType<typeof addRole>): any {
  try {
    const { name, permission: modulePermission, id } = action.payload;

    const formattedPermission: any = {};
    for (const moduleName in modulePermission) {
      formattedPermission[moduleName] = [];

      Object.values(PERMISSION).forEach((permissionKey) => {
        // Permission key will be like w, r which we are using in form
        if (modulePermission[moduleName][permissionKey]) {
          formattedPermission[moduleName].push(permissionKey);
        }
      });
    }

    const result = yield call(request.post, endpoints.addRole, {
      name,
      permissions: formattedPermission,
      id,
    });
    yield put(addRoleSuccess(result.data));
  } catch (err) {
    yield put(addRoleFailed(err));
  }
}

function* updateRoleStatusSagas(action: ReturnType<typeof updateRoleStatus>): any {
  try {
    const { row } = action.payload;
    const result = yield call(request.post, endpoints.roles, {
      id: row.id,
      active: !row.active,
    });
    yield put(updateRoleStatusSuccess(result.data));
  } catch (err) {
    yield put(updateRoleStatusFailed(err));
  }
}

function* roleSaga() {
  yield all([
    takeLatest([getRole, addRoleSuccess, updateRoleStatusSuccess], getRolesSaga),
    takeLatest(getModule, getModuleSaga),
    takeLatest(addRole, addRoleSagas),
    takeLatest(updateRoleStatus, updateRoleStatusSagas),
  ]);
}

export { roleSaga };
